import { SharedDataObraService } from './service/shared-obra/shared-obra.service';

import { CommonModule } from '@angular/common';
import {
  Component,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';
import { CommonLoaderComponent } from '../shared/components/common-loader/common-loader.component';
import { AgendarTarefaComponent } from '../shared/components/detalhes-obra/agendar-tarefa/agendar-tarefa.component';
import { ConclusaoTarefaComponent } from '../shared/components/detalhes-obra/conclusao-tarefa/conclusao-tarefa.component';
import { DescarteRelatoComponent } from '../shared/components/detalhes-obra/descarte-relato/descarte-relato.component';
import { DescarteTarefaComponent } from '../shared/components/detalhes-obra/descarte-tarefa/descarte-tarefa.component';
import { EditarRelatoComponent } from '../shared/components/detalhes-obra/editar-relato/editar-relato.component';
import { EditarTarefaComponent } from '../shared/components/detalhes-obra/editar-tarefa/editar-tarefa.component';
import { NovoRelatoComponent } from '../shared/components/detalhes-obra/novo-relato/novo-relato.component';
import { ObraContratadaComponent } from '../shared/components/detalhes-obra/obra-contratada/obra-contratada.component';
import { ObraPerdidaComponent } from '../shared/components/detalhes-obra/obra-perdida/obra-perdida.component';
import { ReportarErroComponent } from '../shared/components/detalhes-obra/reportar-erro/reportar-erro.component';
import { ModalNotificacaoPermissaoComponent } from '../shared/components/modais/modal-notificacao-permissao/modal-notificacao-permissao.component';
import { SidePanelComponent } from '../shared/components/side-panel/side-panel.component';
import { ContatosComponent } from './contatos/contatos.component';
import { DetalheDaObraComponent } from './detalhe-da-obra/detalhe-da-obra.component';
import { TarefasRelatosComponent } from './tarefas-relatos/tarefas-relatos.component';
import { HeaderService } from '../header/service/header.service';
import { AuthService } from '../shared/services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ObraNavegacaoService } from '../shared/services/obras-navegacao/obras-navegacao.service';
import { ModulosBuscaService } from '../shared/components/filtros-busca/service/modulos-service/modulos.service';
import { FichaBloqueioModuloComponent } from './ficha-bloqueio-modulo/ficha-bloqueio-modulo.component';

interface Tarefa {
  id: number;
  description: string;
}

interface Relato {
  id: number;
  description: string;
  reportID?: number;
  raw?: any;
}

@Component({
  selector: 'app-ficha-da-obra',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    ContatosComponent,
    DetalheDaObraComponent,
    TarefasRelatosComponent,
    CommonLoaderComponent,
    SidePanelComponent,
    NovoRelatoComponent,
    AgendarTarefaComponent,
    EditarTarefaComponent,
    ConclusaoTarefaComponent,
    EditarRelatoComponent,
    DescarteRelatoComponent,
    DescarteTarefaComponent,
    ObraContratadaComponent,
    ObraPerdidaComponent,
    ReportarErroComponent,
    FichaBloqueioModuloComponent
  ],
  templateUrl: './ficha-da-obra.component.html',
  styleUrl: './ficha-da-obra.component.scss',
})
export class FichaDaObraComponent {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  obraName      = '';
  constructorId: number | null = null;
  constructorName = '';
  companyId: number | null = null;
  companyName = '';
 
  isLoadingObra  = false;
  isPanelOpen    = false;
  panelTitle     = '';
  currentPanel: string | null = null;
 
  tarefaSelecionada: Tarefa | null    = null;
  tarefaParaDescarte: Tarefa | null   = null;
  relatoParaDescarte: Relato | null   = null;
 
  activeFichaIndex: number | null = null;
  moduloId: number | null         = null;
  contextoResultado               = false;
 
  idObra: number | null = null;
 
  get somenteLeitura(): boolean {
    return this.detalheDaObraComponent?.somenteLeitura ?? false;
  }

  get motivoSomenteLeitura(): string {
    return this.detalheDaObraComponent?.motivoSomenteLeitura ?? 'Obra encerrada';
  }

  get complementoSomenteLeitura(): string {
    return this.motivoSomenteLeitura === 'Obra cancelada'
      ? 'Esta ficha está disponível apenas para consulta: não é possível alterar o acompanhamento, criar tarefas ou relatos, nem reportar erros.'
      : 'Esta ficha está disponível apenas para consulta.';
  }

  readonly dicaSomenteLeitura = 'Indisponível: obra encerrada';

  podeAvancar = false;
  podeVoltar  = false;

  fichaBloqueada = false;
  moduloBloqueadoId: number | null = null;
 
  @ViewChild(TarefasRelatosComponent)  tarefasRelatosComponent: TarefasRelatosComponent;
  @ViewChild(DetalheDaObraComponent)   detalheDaObraComponent: DetalheDaObraComponent;

 constructor(
    private readonly route: ActivatedRoute,         
    private readonly router: Router,                  
    private readonly obraNavegacaoService: ObraNavegacaoService, 
    private readonly _sharedDataObraService: SharedDataObraService,
    public bsModalRef: BsModalRef,
    private readonly _modalService: BsModalService,
    private readonly _headerService: HeaderService,
    private readonly authService: AuthService,
    private readonly modulosBuscaService: ModulosBuscaService,
  ) {
    const companyIdStr = this.authService.companyID;
    this.companyId  = companyIdStr ? parseInt(companyIdStr) : null;
    this.companyName = localStorage.getItem('companyName') || '';
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
    const id        = Number(params.get('id'));
    const nomeModulo = params.get('modulo'); 
    
    if (!id) {
      this.router.navigate(['']);
      return;
    }

    this.idObra  = id;
    this.moduloId = this.modulosBuscaService.getIdByRota(nomeModulo ?? '');
    
    this.atualizarNavegacao();
  });
 
    this.showNotificationModal();
    this.carregarDadosEmpresa();
  }
 
  ngOnDestroy(): void {
    this._sharedDataObraService.setFichaDaObraActive(false);
  }

  onFichaBloqueada(moduloId: number | null): void {
  this.moduloBloqueadoId = moduloId ?? this.moduloId ?? null;
  this.fichaBloqueada = true;
}
 
  private atualizarNavegacao(): void {
    if (!this.idObra) return;
    this.podeVoltar  = this.obraNavegacaoService.getAnterior(this.idObra) !== null;
    this.podeAvancar = this.obraNavegacaoService.getProximo(this.idObra) !== null;
  }
 
  voltarParaBusca(): void {
    window.history.back();
  }

 
 voltarObra(): void {
  if (!this.idObra) return;
  const anterior = this.obraNavegacaoService.getAnterior(this.idObra);
  if (!anterior) return;
  const modulo = this.obraNavegacaoService.getModuloRota(anterior);
  this.router.navigate(['/buscas', modulo, 'detalhes', anterior], { replaceUrl: true });
}

avancar(): void {
  if (!this.idObra) return;
  const proximo = this.obraNavegacaoService.getProximo(this.idObra);
  if (!proximo) return;
  const modulo = this.obraNavegacaoService.getModuloRota(proximo);
  this.router.navigate(['/buscas', modulo, 'detalhes', proximo], { replaceUrl: true });
}
 
 
  onLoadingObra(status: boolean)    { queueMicrotask(() => (this.isLoadingObra = status)); }
  onModuleIdLoaded(moduleId: number) { this.moduloId = moduleId; }
  onObraNameLoaded(name: string)    { this.obraName = name; }
  onPainelLoading(status: boolean)  { queueMicrotask(() => (this.isLoadingObra = status)); }
 
  openPanel(panel: string, tarefa?: Tarefa) {
    this.currentPanel = panel;
    this.panelTitle   = this.getPanelTitle(panel);
    this.isPanelOpen  = true;
    if (panel === 'editar-tarefa' || panel === 'editar-relato') {
      this.tarefaSelecionada = tarefa || null;
    }
    if (panel === 'reportar-erro' && this.detalheDaObraComponent) {
      this.obraName = this.detalheDaObraComponent['ArrObraDetalhes']?.name || '';
      const constructorCompanyId = this.detalheDaObraComponent.getConstructorCompanyId();
      this.constructorId   = constructorCompanyId;
      this.constructorName = constructorCompanyId
        ? this.detalheDaObraComponent.getConstructorName(constructorCompanyId)
        : '';
      if (!this.companyName) this.carregarDadosEmpresa();
    }
  }
 
  closePanel() {
    this.isPanelOpen       = false;
    this.currentPanel      = null;
    this.tarefaSelecionada = null;
  }
 
  getPanelTitle(panel: string): string {
    const titles: Record<string, string> = {
      'novo-relato':       'Novo Relato',
      'agendar-tarefa':    'Agendar Tarefa',
      'editar-tarefa':     'Editar Tarefa',
      'conclusao-tarefa':  'Conclusão de Tarefa',
      'editar-relato':     'Editar Relato',
      'descarte-relato':   'Descarte de Relato',
      'descarte-tarefa':   'Descarte de Tarefa',
      'obra-contratada':   'Obra Contratada',
      'obra-perdida':      'Obra Perdida',
      'reportar-erro':     'Encontrou um erro?',
    };
    return titles[panel] ?? '';
  }
 
  getModuleName(moduleId: number | null): string {
    if (!moduleId) return '';
    const names: Record<number, string> = {
      234: 'Imobiliário',
      5:   'Industrial',
      6:   'Edificações',
      7:   'Infraestrutura',
    };
    return names[moduleId] ?? '';
  }
 
  carregarDadosEmpresa(): void {
    const companyId      = this.authService.companyID;
    const restrictionKey = this.authService.restrictionKey;
 
    if (!companyId || !restrictionKey) {
      console.warn('companyID ou restrictionKey não encontrados');
      return;
    }
 
    this._headerService.dadosFornecedor(companyId, restrictionKey).subscribe({
      next: (res) => {
        if (res?.data) {
          this.companyId   = res.data.companyID;
          this.companyName = res.data.tradingName || res.data.name || '';
        }
      },
      error: (err) => console.error('Erro ao carregar dados da empresa:', err),
    });
  }
 
  onTarefaCriada()  { this.tarefasRelatosComponent.carregarTarefasRelatos(); }
  onRelatoCriado()  { this.tarefasRelatosComponent.carregarTarefasRelatos(); }
  onRelatoEditado() { this.tarefasRelatosComponent.carregarTarefasRelatos(); }
  onTarefaEditada() { this.tarefasRelatosComponent.carregarTarefasRelatos(); }
 
  fecharDescarteTarefa(atualizarLista = false) {
    this.tarefaParaDescarte = null;
    this.isLoadingObra = false;
    if (atualizarLista) this.tarefasRelatosComponent?.carregarTarefasRelatos();
  }
 
  fecharDescarteRelato(atualizarLista = false) {
    this.relatoParaDescarte = null;
    this.isLoadingObra = false;
    if (atualizarLista) this.tarefasRelatosComponent?.carregarTarefasRelatos();
  }
 
  abrirPainelDescarteTarefa(tarefa: Tarefa) {
    this.tarefaParaDescarte = tarefa;
    this.currentPanel       = 'descarte-tarefa';
    this.panelTitle         = this.getPanelTitle('descarte-tarefa');
    this.isPanelOpen        = true;
  }
 
  abrirPainelDescarteRelato(relato: Relato) {
    this.relatoParaDescarte = relato;
    this.currentPanel       = 'descarte-relato';
    this.panelTitle         = this.getPanelTitle('descarte-relato');
    this.isPanelOpen        = true;
  }
 
  showNotificationModal(): void {
    if (!ModalNotificacaoPermissaoComponent.shouldShowModal(this.authService)) return;

    this.bsModalRef = this._modalService.show(ModalNotificacaoPermissaoComponent, {
      class:                'modal-dialog-centered modal-notification-permission',
      keyboard:             false,
      ignoreBackdropClick:  true,
      backdrop:             true,
    });
  }
}
